export default {
    getClientSettings: state => state.clientSettings,
    getEmail: state => state.sameEmail,
    getNewEmail: state => state.emailChanged,
    getEmailErrors: state => state.emailErrors,
    getDeletionReasons: state => state.deletionReasons,
    getAccountDeleteError: state => state.accountDeleteError,
    getSuccessStatusMessage: state => state.showSuccessMessage
};